import { render, staticRenderFns } from "./HowToUseMidjourney.vue?vue&type=template&id=4a01df98&"
import script from "./HowToUseMidjourney.vue?vue&type=script&lang=js&"
export * from "./HowToUseMidjourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeBenefits: require('/opt/render/project/src/channels2022/src/components/home-page/HomeBenefits.vue').default})
